// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackCircleFilledSvg from "@fishx/icons-svg/es/asn/SlackCircleFilled";
import FishxIcon from '../components/FishxIcon';

var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackCircleFilledSvg
  }));
};

SlackCircleFilled.displayName = 'SlackCircleFilled';
export default React.forwardRef(SlackCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlackCircleFilled.js
// module id = 4142
// module chunks = 0